import {useState } from 'react'

import RegisterTile from '../../Components/RegisterTile/RegisterTile.js';
import './signup-info.css'


const SignupInfo = () => {

    return (
        <div className='signup-info-outer-div'>
            <div className='signup-info-title'>Choose the best plan for your business.</div> 
            <div className='signup-info-tiles'>
                <RegisterTile
                    title='Free Trial'
                    subTitle='Try free for 30 days'
                    body='up to 10 users'
                    color='green'
                    tier='1'
                />
                <RegisterTile
                    title='Monthly Subscription'
                    subTitle='24.99/month'
                    body='unlimited users'
                    color='blue'
                    tier='2'
                />
                <RegisterTile
                    title='Annual Subscription'
                    subTitle='$189/year'
                    body='unlimited users'
                    color='orange'
                    tier='3'
                />
            </div>
        </div>


    )

};

export default SignupInfo;